import Api from '@/api/clinique/_clinique.js'

export default {
    getCountDown() {
        const promise = Api().get('/countdown')
        return promise.then(response => response.data)
    },

    getCodeProduitAssurance(data) {
        const promise = Api().post('/prestations/assurances/get-code-produit', data)
        return promise.then(response => response.data)
    },

    getConfigInfoClinique(data){
        const promise = Api().get('/config/info_clinique/'+data)
        return promise.then(response => response.data)
    },
}